import React, { Component } from 'react';
import axios from "axios";
import Helping from "../../helpers/Helping";
import Notification from "../layout/Notification";
import { create, update } from "../../services/redeem.service";
import { setErrorFields, validateField } from "../../helpers/validationHelpers";
import { connect } from "react-redux";
import route from '../../config/routes';
import { MESSAGE } from '../../config/index';
import LoadingButton from '../fields/LoadingButton';
import { API_URL } from '../../config/urls';
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import Service from '../../helpers/service';
import $ from 'jquery';

const { EMPTY, CREATE, UPDATE, LESS, GREAT } = MESSAGE;
class Create extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageTitle: 'Add New Redeem Code',
            buttonTitle: 'Save',
            code: '',
            type: '',
            item_code: '',
            is_active: true,
            max_limit: '',
            remaining: '',
            description: '',
            start_date: '',
            expiry_date: '',
            url: API_URL.ADMIN_TRADING_API + route.GET_REDEEM,
            routeName: route.LIST_REDEEM,
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsDisable: false
        };

        this.onUpdate = this.onUpdate.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    scrollToTop = () => {
        $('.addButton-slide').animate({ scrollTop: 0 }, 'slow');
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    handelDateChange = async (date, field) => {
        let value = date.target.value;

        let remainingLimit = {
            name: 'start date',
            value: this.state.start_date,
            check: GREAT,
        },
            limit = {
                name: 'expiry date',
                value: this.state.expiry_date,
                check: LESS,
            };
        if (field === 'start_date') {
            this.setState({ ...(await validateField('dateTime', field, value, '', 1, 'start date', limit, true, true)) });
        }
        if (field === 'expiry_date') {
            this.setState({ ...(await validateField('dateTime', field, value, '', 1, 'expiry date', remainingLimit, true, true)) });
        }
        this.setState({ [field]: value });
    }

    handleChange = async (e) => {
        const { name, value } = e.target;

        let remainingLimit = {
            name: 'limit',
            value: this.state.max_limit.length > 0 ? this.state.max_limit : 1,
            check: LESS,
        },
            limit = {
                name: 'remaining',
                value: this.state.remaining.length > 0 ? this.state.remaining : 0,
                check: GREAT,
            };

        this.setState({ [name]: value }, () => {
            remainingLimit = { value: this.state.max_limit };
            limit = { value: this.state.remaining };
        });
        if (name === 'code')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
        if (name === 'item_code')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
        if (name === 'type')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
        if (name === 'max_limit')
            this.setState({ ...(await validateField('numeric', name, value, '', 1, 'limit', limit, true)) });
        if (name === 'remaining')
            this.setState({ ...(await validateField('numeric', name, value, '', 1, 'remaining', remainingLimit, true)) });
    }

    componentDidMount() {
        var $this = this;
        this.setErrorOnApiCall();

        if (!this.props.id) {
            this.setState({
                isLoading: false
            });
        }
        $(".close-slide").click(function () {
            $this.resetForm();
            $this.removeNetworkError();
            $this.setState({
                pageTitle: 'Add Redeem Code',
                buttonTitle: 'Save'
            })
            $this.props.closeEditModal();
        });

        if (this.props.id) {
            let id = this.props.id;
            $this.setState({
                pageTitle: 'Edit Redeem Code',
                buttonTitle: 'Update'
            });

            $this.getById(id);
        }
    }

    resetForm = () => {
        this.setState({
            code: '',
            is_active: true,
            max_limit: '',
            start_date: '',
            expiry_date: '',
            description: '',
            remaining: '',
            type: '',
            item_code: '',
            isLoading: true,
            btnIsDisable: false,
            error_code_message: '',
            error_limit_message: '',
            error_remaining_message: '',
            error_description_message: '',
            error_expiry_date_message: '',
            error_start_date_message: '',
        })
    }

    checkEmptyFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.code.length === 0) {
            let errorObject = setErrorFields("code", Helping.getMessageString(EMPTY, "Code"));
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.item_code.length === 0) {
            let errorObject = setErrorFields("item_code", Helping.getMessageString(EMPTY, "Item Code"));
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.type.length === 0) {
            let errorObject = setErrorFields("type", Helping.getMessageString(EMPTY, "Type"));
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.max_limit.length === 0) {
            let errorObject = setErrorFields("max_limit", Helping.getMessageString(EMPTY, "Limit"));
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.start_date.length === 0) {
            let errorObject = setErrorFields(
                'start_date',
                Helping.getMessageString(EMPTY, 'Start date')
            );
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.expiry_date.length === 0) {
            let errorObject = setErrorFields(
                'expiry_date',
                Helping.getMessageString(EMPTY, 'Expiry date')
            );
            this.setState({ ...errorObject });
            formHasError = true;
        }

        return formHasError;
    }

    getById(id) {
        var $this = this;

        axios.post(this.state.url, {
            "action": "get-by-id",
            id
        }, Helping.getConfig()).then(response => {
            const redeem = response.data.payload;

            $this.setState({
                code: redeem.code,
                type: redeem.type,
                item_code: redeem.item_code,
                is_active: redeem.is_active,
                max_limit: redeem.max_limit,
                remaining: redeem.remaining,
                description: redeem.description,
                start_date: Helping.convertUnixTimeStampToISO(redeem.start_date),
                expiry_date: Helping.convertUnixTimeStampToISO(redeem.end_date),
                isLoading: false
            });
        }).catch(error => {
            if (error.response) {
                Helping.redirectToLogin(error);
                return $this.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    isLoading: false
                });
            }
            return this.setState({
                isLoading: false,
                ...Helping.setNetworkRequestError(error, "fetching redeem")
            })
        });
    }

    onSave(e) {
        e.preventDefault();

        let $this = this;
        let formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            "action": "create",
            "code": this.state.code,
            "type": this.state.type,
            "item_code": this.state.item_code,
            "max_limit": Number(this.state.max_limit),
            "remaining": Number(this.state.remaining),
            "is_active": this.state.is_active,
            "description": this.state.description,
            "start_date": Helping.convertTimeStampToUnixTimeStamp(this.state.start_date),
            "end_date": Helping.convertTimeStampToUnixTimeStamp(this.state.expiry_date),
        };

        Service.postCall(this.state.url, data).then(response => {
            this.props.create(response.data.payload);
            this.setState(
                {
                    error_message: Helping.getMessageString(CREATE, "redeem"),
                    error_type: "success",
                    btnIsDisable: false
                }, () => { this.scrollToTop(); this.resetForm() }
            );
        }).catch(error => {
            console.log({ error });
            if (error.response) {
                Helping.redirectToLogin(error);
                return $this.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    btnIsDisable: false
                }, () => { this.scrollToTop(); });
            }
            return this.setState({
                isLoading: false,
                btnIsDisable: false,
                ...Helping.setNetworkRequestError(error, "creating redeem")
            }, () => { this.scrollToTop(); })
        });
    }

    onUpdate(e) {
        e.preventDefault();

        let $this = this,
            id = this.props.id,
            formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            "action": "update",
            "id": id,
            "code": this.state.code,
            "type": this.state.type,
            "item_code": this.state.item_code,
            "remaining": Number(this.state.remaining),
            "max_limit": Number(this.state.max_limit),
            "is_active": this.state.is_active,
            "description": this.state.description,
            "start_date": Helping.convertTimeStampToUnixTimeStamp(this.state.start_date),
            "end_date": Helping.convertTimeStampToUnixTimeStamp(this.state.expiry_date),
        };

        Service.postCall(this.state.url, data).then(response => {
            $this.props.update(response.data.payload);
            $this.setState(
                {
                    error_message: Helping.getMessageString(UPDATE, "redeem"),
                    error_type: "success",
                    btnIsDisable: false
                }, () => { this.scrollToTop(); this.resetForm() }
            );
        }).catch(error => {
            if (error.response) {
                Helping.redirectToLogin(error);
                return $this.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    btnIsDisable: false
                }, () => { this.scrollToTop(); });
            }
            return this.setState({
                isLoading: false,
                btnIsDisable: false,
                ...Helping.setNetworkRequestError(error, "updating redeem")
            }, () => { this.scrollToTop(); })
        });
    }

    render() {
        var minDate = Helping.currentTimeStampInISO();

        return (
            <div class="addButton-slide right-slider add-redeem">
                <div class="slide-top">
                    <div class="slide-header">
                        <h4 class="title">{this.state.pageTitle}</h4>
                        <span class="caption">{this.state.pageTitle} and give details about them.</span>
                    </div>
                    {/* <span class="close-slide">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                    </span> */}
                </div>

                {this.state.error_message &&
                    <Notification
                        type={this.state.error_type}
                        message={this.state.error_message}
                        callback={this.removeNetworkError}
                    />
                }

                <form class="info">
                    <div class="form-group">
                        <label for="redeemCode">Redeem Code</label>
                        <input type="text" name="code" class={`form-control ${this.state.error_code_message ? 'error-input' : ''}`} value={this.state.code} id="redeemCode" onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_code_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="itemCode">Item Code</label>
                        <input type="text" name="item_code" class={`form-control ${this.state.error_item_code_message ? 'error-input' : ''}`} value={this.state.item_code} id="itemCode" onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_item_code_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="redeemLimit">Limit</label>
                        <input type="number" name="max_limit" class={`form-control ${this.state.error_max_limit_message ? 'error-input' : ''}`} value={this.state.max_limit} id="redeemLimit" onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_max_limit_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="redeemRemain">Remaining</label>
                        <input type="number" name="remaining" class={`form-control ${this.state.error_remaining_message ? 'error-input' : ''}`} value={this.state.remaining} id="redeemRemain" onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_remaining_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="type">Type</label>
                        <select class={`form-select ${this.state.error_type_message ? 'error-input' : ''}`} name="type" aria-label="" id="type" value={this.state.type} onChange={(e) => this.handleChange(e)}>
                            <option value=''>Select Type...</option>
                            <option value='default'>Default</option>
                            <option value='cardano'>Cardano</option>
                            <option value='cmc'>Cmc</option>
                            <option value='nitro'>Nitro</option>'
                            <option value='ascendex'>Ascendex</option>
                            <option value='isl'>ISL</option>
                        </select>
                        <span className="error-msg">{this.state.error_type_message}</span>
                    </div>
                    <div class="form-group-tabs">
                        <label for="">Status</label>
                        <div class="category-tabs">
                            <ul class="nav nav-pills">
                                <li class="tab-item">
                                    <a class={this.state.is_active ? "active" : ""} href="#online" data-toggle="tab" onClick={() => this.setState({ is_active: true })}>Online</a>
                                </li>
                                <li class="tab-item">
                                    <a class={!this.state.is_active ? "active" : ""} href="#offline" data-toggle="tab" onClick={() => this.setState({ is_active: false })}>Offline</a>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-content">
                            <div class={`tab-pane ${this.state.is_active ? "active" : ""}`} id="online">
                                <div class="form-group">
                                    <label for="startDate">Start Date</label>

                                    <input type="datetime-local"
                                        min={!this.props.id ? minDate : null}
                                        name="start_date" class={`form-control ${this.state.error_start_date_message ? 'error-input' : ''}`}
                                        value={this.state.start_date} id="startDate"
                                        onChange={(date) => this.handelDateChange(date, "start_date")}
                                    />
                                    <span className="error-msg">{this.state.error_start_date_message}</span>
                                </div>
                                <div class="form-group">
                                    <label for="EndDate">End Date</label>
                                    <input type="datetime-local"
                                        min={!this.props.id ? minDate : null}
                                        name="expiry_date" class={`form-control ${this.state.error_expiry_date_message ? 'error-input' : ''}`}
                                        value={this.state.expiry_date} id="EndDate"
                                        onChange={(date) => this.handelDateChange(date, "expiry_date")}
                                    />
                                    <span className="error-msg">{this.state.error_expiry_date_message}</span>
                                </div>
                                <div class="form-group">
                                    <label for="categoryDetail">Description</label>
                                    <textarea class={`form-control ${this.state.error_description_message ? 'error-input' : ''}`} name="description" id="categoryDetail" value={this.state.description} rows="3" onChange={(e) => this.handleChange(e)}></textarea>
                                    <span className="error-msg">{this.state.error_description_message}</span>
                                </div>
                            </div>
                            <div class={`tab-pane ${!this.state.is_active ? "active" : ""}`} id="offline">
                                <div class="form-group">
                                    <label for="startDate">Start Date</label>

                                    <input type="datetime-local"
                                        min={!this.props.id ? minDate : null}
                                        name="start_date" class={`form-control ${this.state.error_start_date_message ? 'error-input' : ''}`}
                                        value={this.state.start_date} id="startDate"
                                        onChange={(date) => this.handelDateChange(date, "start_date")}
                                    />
                                    <span className="error-msg">{this.state.error_start_date_message}</span>
                                </div>
                                <div class="form-group">
                                    <label for="EndDate">End Date</label>
                                    <input type="datetime-local"
                                        min={!this.props.id ? minDate : null}
                                        name="expiry_date" class={`form-control ${this.state.error_expiry_date_message ? 'error-input' : ''}`}
                                        value={this.state.expiry_date} id="EndDate"
                                        onChange={(date) => this.handelDateChange(date, "expiry_date")}
                                    />
                                    <span className="error-msg">{this.state.error_expiry_date_message}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="slide-btn">
                        <div className="float-left">
                            <button class="close-slide custom-btn semi-dark-btn sm-btn" onClick={e => e.preventDefault()}>Close</button>
                        </div>

                        <div class="float-right">
                            {!this.props.id &&
                                <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { e.preventDefault(); this.resetForm() }}>Reset</button>
                            }
                            {this.state.btnIsDisable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                this.props.id ? (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onUpdate(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                ) : (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                )}
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    profile: state.profile
})

const mapDispatchToProps = {
    create,
    update,
    addCurrentRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(Create)